<template>
	<ActivityDeclarationCom />
</template>

<script>
import ActivityDeclarationCom from 'components/activityDeclaration/activityDeclaration';
export default {
  name: 'ActivityDeclaration',

  components:{
    ActivityDeclarationCom
  },

  data () {
    return {
    }
  },

  computed: {

  },

  created() {
  },

  mounted() {},
}
</script>


<style lang='scss'>
</style>
